import { BaseDesignOption } from '@/modules/ta/reportstudio/models/element/metadata/BaseDesignOption';
import {
  ShapeDefaultProps,
  ReportElementLineStyle,
  ReportElementLineCap,
} from '@/modules/ta/reportstudio/reportstudio.constants';

export class ShapeDesignOption extends BaseDesignOption {
  /**
   * @type {boolean}
   */
  show_on_every_page;

  /**
   * @type {string}
   */
  border_radius;

  /**
   * @type {string}
   */
  background_color;

  /**
   * SVG stroke color. Applies to SVG-based shapes only.
   * @type {string|null}
   */
  stroke_color;

  /**
   * SVG stroke width in pixels. Applies to SVG-based shapes only.
   * @type {number}
   */
  stroke_width;

  /**
   * Number of corners for the Polygon shape (3–20).
   * @type {number}
   */
  corners;

  /**
   * Inner radius percentage for the Polygon shape (100 = regular polygon, <100 = star).
   * @type {number}
   */
  inner_radius;

  /**
   * Stroke dash style for the Line shape.
   * @type {string}
   */
  line_style;

  /**
   * Cap style for the left (start) end of the Line shape.
   * @type {string}
   */
  line_start_cap;

  /**
   * Cap style for the right (end) end of the Line shape.
   * @type {string}
   */
  line_end_cap;

  constructor(model = {}) {
    super();
    this.show_on_every_page = model.show_on_every_page ?? true;
    this.border_radius = model.border_radius ?? '0%';
    this.background_color = model.background_color;
    this.stroke_color = model.stroke_color ?? null;
    this.stroke_width = model.stroke_width ?? ShapeDefaultProps.DEFAULT_STROKE_WIDTH;
    this.corners = model.corners ?? 5;
    this.inner_radius = model.inner_radius ?? 100;
    this.line_style = model.line_style ?? ReportElementLineStyle.SOLID;
    this.line_start_cap = model.line_start_cap ?? ReportElementLineCap.NONE;
    this.line_end_cap = model.line_end_cap ?? ReportElementLineCap.NONE;
  }
}
